module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av231-3c2c44376d02471884813e7f2889595f.jpg";